var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":_vm.exportToCsv}},'v-btn',attrs && _vm.$attrs,false),on),[_c('v-icon',[_vm._v("fas fa-file-csv")])],1)]}}])},[_c('span',[_vm._v("Export as csv")])])}
var staticRenderFns = []

export { render, staticRenderFns }